(() => {
  class CinotonProductContentVideo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.playButton = this.querySelector('[data-cinoton-content-play]');
      this.cover = this.querySelector('[data-cinoton-content-cover]');
      this.player = this.querySelector('[data-cinoton-content-player]');
      this.playButton?.addEventListener('click', () => this.play());
    }

    play() {
      if (!this.player || !this.cover) return;
      this.cover.hidden = true;
      this.player.hidden = false;
      this.classList.add('is-playing');

      const video = this.player.querySelector('video');
      if (video) {
        video.play().catch(() => {});
        return;
      }

      const mount = this.player.querySelector('[data-cinoton-external-video]');
      if (!mount || mount.firstElementChild) return;
      const host = mount.dataset.videoHost;
      const id = encodeURIComponent(mount.dataset.videoId || '');
      if (!id) return;
      const source = host === 'vimeo'
        ? `https://player.vimeo.com/video/${id}?autoplay=1`
        : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      const iframe = document.createElement('iframe');
      iframe.src = source;
      iframe.title = mount.dataset.videoTitle || 'Product video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      mount.appendChild(iframe);
    }
  }

  if (!customElements.get('cinoton-product-content-video')) {
    customElements.define('cinoton-product-content-video', CinotonProductContentVideo);
  }
})();
